/* 완료 모임 화면 미리보기 — 데이터 없이 레이아웃을 확인할 때 씁니다 (/ds/finished). */
import { MeetingFinishedView } from 'components/meeting/MeetingFinishedView';

const meeting = {
    name: '가을밤 와인 한 잔',
    meetingType: 'DAY',
    date: '2026년 8월 29일 (토)',
    time: '오후 7:00',
    location: '연남동 와인바 보떼',
    locationDetail: '서울 마포구 연희로1길 41 1층',
    totalPaymentAmount: 184000,
    myBalanceAmount: 46000,
    myUnsettledAmount: 0,
    hasUnsettledPayment: true,
    endedAt: new Date(Date.now() - 1000 * 60 * 60 * 3).toISOString(),
};

const participants = [
    { id: 1, userNo: 1, name: '윤재권', isCreator: true, status: 'confirmed' },
    { id: 2, userNo: 2, name: '이수진', status: 'confirmed' },
    { id: 3, userNo: 3, name: '박민수', status: 'confirmed' },
    { id: 4, userNo: 4, name: '최지영', status: 'declined' },
];

const payments = [
    {
        paymentId: 'p1', paidByNo: 1, paidByNickname: '윤재권', creatorNo: 1,
        storeName: '보떼', totalAmount: 124000, status: 'ACTIVE',
        splits: [
            { splitId: 11, userNo: 1, userNickname: '윤재권', amount: 41000, isSent: true },
            { splitId: 12, userNo: 2, userNickname: '이수진', amount: 41000, isSent: true },
            { splitId: 13, userNo: 3, userNickname: '박민수', amount: 42000, isSent: false },
        ],
    },
    {
        paymentId: 'p2', paidByNo: 2, paidByNickname: '이수진', creatorNo: 2,
        storeName: '연남 커피로스터스', totalAmount: 60000, status: 'ACTIVE',
        splits: [
            { splitId: 21, userNo: 1, userNickname: '윤재권', amount: 20000, isSent: false },
            { splitId: 22, userNo: 2, userNickname: '이수진', amount: 20000, isSent: true },
            { splitId: 23, userNo: 3, userNickname: '박민수', amount: 20000, isSent: false },
        ],
    },
];

export const FinishedPreview = () => (
    <MeetingFinishedView
        meeting={meeting}
        subPlaces={[
            { subPlaceId: 11, category: 'SECONDARY', placeName: '연남 커피로스터스', placeAddress: '서울 마포구 성미산로 161', visitTime: '21:00', sortOrder: 1 },
        ]}
        hotelPlace={null}
        participants={participants}
        isCreator
        meetingId="preview"
        payments={payments}
    />
);
